export function AdSlot({ placement }: { placement: 'LANDING_MIDDLE' | 'LANDING_BOTTOM' | 'DASHBOARD_SIDEBAR' }) {
  return <aside className="ad-slot" aria-label="Advertisement" data-placement={placement}>Advertisement</aside>
}
